import React from 'react';

export default function FaqPage() {
	return (
		<section id="body">
			<div className="container">
				<div className="row shadow title position-relative">
					<div className="col-12">
						<h2 className="text-center m-5 text-white font-weight-bold">Frequently Asked Questions</h2>
					</div>
				</div>
				<div className="row content">
					<div className="col-1"></div>
					<div className="col-10 px-0 shadow bg-white rounded">
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">1.</label>
								<label className="col-10 col-form-label">
								What is this product about?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								This product provides choices of Critical Illness coverage with 3 options and 5 plans depending on your needs. Coverage options includes Advanced Stage, Early Stage and Diabetic Care Disease.<br></br>
This product provides lump sum payment for any of the covered Critical Illness diagnosed at either the Early and/or Advanced Stage as stated in your Schedule of Benefits, depending on the coverage you have chosen.<br></br>
Diabetic Care Disease provides a lump sum payment for the covered conditions. Claims made under Diabetic Care Disease benefit will not decrease the Sum Insured of your plan. However, if claims are made under Diabetic Care Disease, this benefit shall be terminated.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">2.</label>
								<label className="col-10 col-form-label">
								Who is eligible for this insurance?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								It is open to either Malaysian citizen, Permanent Residence of Malaysia or a legal work permit or employment pass holder who is legally residing in Malaysia.
Age eligibility: age between 15 days to 60 years old, renewal up to 70 years old.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">3.</label>
								<label className="col-10 col-form-label">What are the pay-outs for Advanced Stage Critical Illness and Early Stage Critical Illness?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								<b>Advanced Stage Critical Illness</b><br></br>
								100% of the Sum Insured (except for Angioplasty and other invasive treatments for coronary artery disease if the Insured Person purchases 39 Critical Illness), less any benefit paid out previously under the Policy will be paid provided that the Insured Person survives for at least 7 days after the diagnosis of the Critical Illness.
								Thereafter, the Policy will automatically terminate, and the policy is non-renewable.<br></br>
								<b>Early Stage Critical Illness</b><br></br>
								50% of the Sum Insured will be paid provided that the Insured Person survives for at least 7 days after the diagnosis of the Critical Illness.
								Thereafter, no benefit will be payable for future claims under Early Stage of any Critical Illness Category.
								The Critical Illness Sum Insured shall be reduced by the Early Stage Critical Illness Benefit payout under the Policy.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">4.</label>
								<label className="col-10 col-form-label">How does it work?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									Assuming on 1/1/2022, a 30-year old non-smoker male buys Critical Safe+ with the following coverage(s) and plan:<br></br>
									<b>Coverage:</b> Top 5 Critical Illnesses with Early Stage and Diabetic Care Disease <br></br>
									<b>Plan:</b> 3 (Sum insured: RM100,000) <br></br><br></br>
									Kindly refer below table on how the payment of claim is payable for the Critical Illness policy:
									<br></br>
									<table className='table table-bordered'>
										<thead>
											<tr>
												<th>Claim</th>
												<th>Diagnisis</th>
												<th>Critical Illness Stage</th>
												<th>Benefit Payable</th>
												<th>Remaining Sum Insured</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>1st claim <br></br> (24/12/2025)</td>
												<td>Carcinoma In Situ</td>
												<td>Early Stage</td>
												<td>100K x 50% = RM50K</td>
												<td>RM50K</td>
											</tr>
											<tr>
												<td>2nd claim <br></br> (1/6/2027)</td>
												<td>Insertion of Pacemaker due to Serious Cardiac condition</td>
												<td>Early Stage</td>
												<td>Not payable </td>
												<td>RM50K</td>
											</tr>
											<tr>
												<td>3rd claim <br></br> (19/7/2029)</td>
												<td>Severe Diabetic Nephropathy</td>
												<td>Diabetic Care</td>
												<td>RM25K</td>
												<td>RM50K</td>
											</tr>
											<tr>
												<td>4th claim <br></br> (29/9/2031)</td>
												<td>Serious Coronary Artery Disease</td>
												<td>Advanced Stage</td>
												<td>(RM100Kx100%) – RM50K = RM50K</td>
												<td>Policy terminated2</td>
											</tr>
										</tbody>
									</table>
									Total Claims payable: RM50,000 + RM25,000 + RM50,000 = RM125,000 (including claim paid under Diabetic Care Disease).<br></br>
1. If 2nd claim is from the same Critical Illness Stage (Early Stage) as previous claim (i.e 1st claim), such 2nd claim will not be payable by us.<br></br>
2. Policy terminated as the Sum Insured RM100k has been fully paid.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">5.</label>
								<label className="col-10 col-form-label">What is mandatory coverage under Critical Safe+?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								You must choose 1 of the 2 options specified below (Advanced Stage Critical Illness):<br></br>
								Option 1 – Top 2 Critical Illnesses
								<ul>
									<li>Heart Attack - of specified severity</li>
									<li>Cancer - of specified severity and does not cover very early cancers</li>
								</ul>
Option 2 – Top 5 Critical Illnesses
<ul>
	<li>Heart Attack - of specified severity</li>
	<li>Cancer - of specified severity and does not cover very early cancers</li>
	<li>Stroke - resulting in permanent neurological deficit with persisting clinical symptoms</li>
	<li>Serious Coronary Artery Disease</li>
	<li>Kidney Failure - requiring dialysis or kidney transplant</li>
</ul>
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">6.</label>
								<label className="col-10 col-form-label">Any optional Cover provided on top of Advanced Stage Critical Illness for this product?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								There are 2 optional covers as specified below. However, these optional covers are only applicable for Top 5 Critical Illness and 39 Critical Illness option only.
								<ol>
									<li>Early Stage Critical Illness
										<ul>
											<li>Heart Attack
												<ul>
													<li>Insertion of Cardiac Defibrillator</li>
													<li>Insertion of Pacemaker</li>
												</ul>
											</li>
											<li>Cancer
												<ul>
													<li>Carcinoma in situ</li>
													<li>Early Prostate Cancer</li>
													<li>Early Thyroid Cancer</li>
													<li>Early Bladder Cancer</li>
													<li>Early Chronic Lymphocytic Leukemia</li>
													<li>Surgical Excision of a Spinal Meningioma</li>
												</ul>
											</li>
											<li>Stroke
												<ul>
													<li>Carotid Artery Surgery</li>
												</ul>
											</li>
											<li>Coronary Artery Disease
											</li>
											<li>Kidney Failure
												<ul>
													<li>Chronic Kidney Disease</li>
												</ul>
											</li>
										</ul>
									</li>
									<li>Diabetic Care Disease
										<ul>
											<li>Surgery for Type 2 Diabetic Retinopathy</li>
											<li>Limb Amputation due to Type 2 Diabetic Complications</li>
											<li>Severe Diabetic Nephropathy</li>
										</ul>
									</li>
								</ol>
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">7.</label>
								<label className="col-10 col-form-label">Is there a waiting period?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								Yes, there is waiting period applied for this insurance as below:
								<table className='table table-bordered'>
										<thead>
											<tr>
												<th>Description</th>
												<th>Waiting Period</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>Advanced Stage Critical Illness</td>
												<td>30 days</td>
											</tr>
											<tr>
												<td>Early Stage Critical Illness</td>
												<td>60 days</td>
											</tr>
											<tr>
												<td>Diabetic Care Disease</td>
												<td>60 days</td>
											</tr>
										</tbody>
									</table>
								</label>

							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">8.</label>
								<label className="col-10 col-form-label">What is survival period?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								Survival period means the period of 7 days after the diagnosis of a covered Critical Illness for which you must survive before a claim becomes valid.
							</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">9.</label>
								<label className="col-10 col-form-label">Can I change my insurance coverage (add on optional cover, upgrade or downgrade) after purchasing this insurance?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								No, there is no option to add on the optional cover, upgrade or downgrade the insurance coverage after purchasing this insurance. Please ensure the plan that you choose is sufficient for your needs before making payment.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">10.</label>
								<label className="col-10 col-form-label">What is the difference between Critical Illness and medical insurance (Hospital & Surgical insurance)?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								Critical illness provides financial support and pay a lump sum pay-out if you are diagnosed with a covered critical illness.
Medical insurance provides financial support by paying for your hospitalization bills if you are admitted to a hospital due to a covered medical condition.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">11.</label>
								<label className="col-10 col-form-label">Do I need to go for a medical check-up?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								No, you just need to answer a few health questions during the purchase process, and it is subject to our acceptance.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">12.</label>
								<label className="col-10 col-form-label">How much premium do I have to pay?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								The premium you have to pay is depends on the option, plan type, your attained age next birthday, gender and smoking status. Please refer to Premium Table for the premium that you need to pay.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">13.</label>
								<label className="col-10 col-form-label">Is the premium rate guaranteed?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								The premium rate is not guaranteed and may be revised from time to time. 30 days written notice in advance will be given to you and the premium revision will be applicable from the next policy anniversary.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">14.</label>
								<label className="col-10 col-form-label">Can I have more than one policy?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								You are only allowed to sign up for one policy only.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">15.</label>
								<label className="col-10 col-form-label">What are the circumstances the policy will be automatically terminated?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								The policy will be automatically terminated upon the first occurrence of any one of the following events:
								<ul>
									<li>termination in accordance with the grace period clause under the Premium and Charges Provision of the policy contract;</li>
									<li>cancellation of the policy;</li>
									<li>lapsation of the policy;</li>
									<li>on the expiry date;</li>
									<li>100% of the Critical Illness sum insured has been fully paid;</li>
									<li>when the Insured Person ceases to satisfy any one of the eligibility criteria stated above in item 2; or</li>
									<li>death of the Insured Person.</li>
								</ul>
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">16.</label>
								<label className="col-10 col-form-label">What is the claim procedure?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									<ul>
										<li>You are required to send us a duly completed claim form and signed by you and your physician as soon as you can, no later than 30 days from the date of diagnosis of a disability made by your physician; and</li>
										<li>You are required to provide us with a copy of completed medical report by your physician stipulating the diagnosis of the condition treated and the date the disability commenced in the physician’s opinion, bill, receipts and other related diagnostic report; and</li>
										<li>You shall promptly give us all information we have requested.</li>
									</ul>
									Please send all your claim documentation to instapol@howdengroup.com.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">17.</label>
								<label className="col-10 col-form-label">What are some of the exclusions under the insurance?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									<ul>
										<li>any Pre-Existing Illness which has existed prior to the issue date or any date of reinstatement of this policy, whichever is later</li>
										<li>any Critical Illness or Diabetic Care Disease resulting directly from alcohol or drug abuse</li>
										<li>any illness, injury or disability arising from any unlawful or illegal act of the Insured Person</li>
										<li>any Critical illness or Diabetic Care Disease arising from Congenital Conditions or deformities including hereditary conditions</li>
										<li>the Insured Person refusing to consent to treatment or defying the advice of a special physician</li>
										<li>hazardous sports or pastimes including taking part in (or practicing for) professional sports, aerial sports, boxing, caving, climbing, horse-racing, jet-skiing, martial arts, mountaineering, off-piste skiing, pot-holing, power-boat racing, underwater diving, yacht racing or any race, trial or timed motor sport</li>
										<li>the Insured Person is directly or indirectly involved in any of the occupations/duties listed below:
											<ul>
												<li>Equestrian Jockeys, Racing Drivers, Professional Athletes</li>
												<li>Military, Armed Forces/Armed Personnel, Bodyguards</li>
												<li>Ship Crew, Shipbuilding and Repair Workers, Agricultural, Forestry or Fishery Workers</li>
												<li>Seamen, Divers, Oil and Gas Rig Workers, Power Plants Workers, Firefighters</li>
												<li>Mining Workers who work underground or use explosives/chemicals</li>
												<li>Construction workers for dams, bridges, tunnels or underground work</li>
												<li>Window cleaners and construction workers at heights exceeding 30 ft above ground</li>
												<li>Workers that handle boilers, pressure vessels, explosives or toxic materials.</li>
												<li>Circus Performers, Stuntmen/Stuntwomen, Prison Officers, Wild Animal Handlers</li>
												<li>Workers handling explosives and other toxic materials.</li>
												<li>Heavy machinery and truck drivers</li>
											</ul>
										</li>
									</ul>
									Note: This list is non-exhaustive. Please refer to the Policy Wording for the full list of exclusions under the Policy.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">18.</label>
								<label className="col-10 col-form-label">What are the disadvantages of switching policy from one insurer to another?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								If you switched to another insurer and your current health status is less favourable to the new insurer, you may be subject to new terms and conditions from the new insurer and have to go through the standard waiting period before you can make any claim.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">19.</label>
								<label className="col-10 col-form-label">I realised that I made a mistake in declaration or information after submitting my application. What can I do?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								Please contact us at 1-800-88-5753 or email us at instapol@howdengroup.com and we will help you to resolve your issues.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">20.</label>
								<label className="col-10 col-form-label">How often do I need to make premium payment?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">You may choose to pay your premium monthly or annually.</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">21.</label>
								<label className="col-10 col-form-label">Will payment be deducted automatically from my card or account every month?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">Yes, once the payment details have been captured. We will charge the recurring monthly premium every month automatically when it becomes due.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">22.</label>
								<label className="col-10 col-form-label">Can I change from monthly payments to annual payments (or vice versa)?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">You are only allowed to make payment mode changes upon renewal (i.e on the policy anniversary).
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">23.</label>
								<label className="col-10 col-form-label">Is there a price difference for monthly and annual payments?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">Yes, you can enjoy better savings if you opt to pay premiums annually compared to monthly.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">24.</label>
								<label className="col-10 col-form-label">Is the premium paid eligible for Income Tax Relief?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">Yes, the premium you have paid may qualify for income tax relief subject to the terms and conditions of the Inland Revenue Board of Malaysia.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">25.</label>
								<label className="col-10 col-form-label">Will I be subjected to any new terms upon renewal if I have made a claim?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">No, we will invite renewal as per existing terms as long as your sum insured is not exhausted.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">26.</label>
								<label className="col-10 col-form-label">Is there any after sales & claims services offered to customer after insurance purchase?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">Yes, instaPol from Howden provides (1) Product Advisory, offering ongoing support to clients regarding insurance-related queries post-purchase (2) Assistance in changing / updating policy details (3) Claims assistance.  Alternatively, you may also contact your chosen insurance company or takaful operator.								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">27.</label>
								<label className="col-10 col-form-label">Can I purchase this product directly from the insurance company / takaful operator?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">Yes, you may purchase insurance / takaful directly from any insurer or takaful operator by visiting their nearest branch or through their website.							</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">28.</label>
								<label className="col-10 col-form-label">Is there a Free-look / Cooling-off period?								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">Within 15 calendar days from the delivery date of the insurance policy / takaful certificate, you may cancel and return the policy to the insurance company / takaful operator for refund of premium subject to the policy's Free Look / Cooling-off terms and conditions.							</label>
							</div>
						</div>
					</div>
					<div className="col-1"></div>
				</div>
			</div>
				
			<div className="row footer my-5">
				<div className="col-12 text-right">
					<a className="btn btn-success mr-3" href="/Landing">Return to Home Page</a>
					<a className="btn btn-success" href="/critical-safe">Get Quote</a>
				</div>
			</div>
		</section>
	);
}